<template>
    <div class="content">
        <h1>LOGVIEW</h1>
        <div
            v-if="logData"
            class="grid"
            v-for="(item, index) in logData"
            :key="index">
            <span v-if="index === 0" class="head">Time</span>
            <span v-if="index === 0" class="head">Page</span>
            <span v-if="index === 0" class="head">Action</span>
            <span v-if="index === 0" class="head">UserIp</span>
            <span v-if="index === 0" class="head">Browser</span>
            <span>
                {{ item.time }}
            </span>
            <span>
                {{ item.page }}
            </span>
            <span>
                {{ item.action }}
            </span>
            <span>
                {{ item.userip }}
            </span>
            <span>
                {{ item.browser }}
            </span>
        </div>
        <div v-if="error">
            {{ error }}
        </div>
    </div>
</template>

<script>
import siteConfig from '@/assets/js/mixins/siteConfig';
import JQuery from 'jquery';
let $ = JQuery;

export default {
    name: 'logview',
    mixins: [
        siteConfig
    ],
    data() {
        return {
            filter: {
                date: null
            },
            logData: null,
            error: null
        };
    },
    methods: {
        initAction() {
            let request = $.ajax({
                url: siteConfig.ajaxUrl + 'logview.php',
                type: 'POST',
                data: 'filter=' + JSON.stringify(this.filter),
                dataType: 'html'
            });

            const that = this;
            request.done(function(result) {
                if (JSON.parse(result)) {
                    that.logData = JSON.parse(result);
                } else {
                    this.error = 'ERROR';
                }
            });

            request.fail(function(jqXHR, textStatus) {
                this.error = jqXHR + '<br><br>' + textStatus;
            });
        }
    },
    created() {
        this.initAction();
    }
};
</script>

<style lang="scss" scoped>
    .grid {
        display: grid;
        grid-template-columns: repeat(5, 1fr);
        border-right: 1px solid lightgray;
    }

    .grid > span {
        padding: 8px 4px;
        border-left: 1px solid lightgray;
        border-bottom: 1px solid lightgray;
    }
    .head {
        border-top: 1px solid lightgray;
        font-weight: bold;
    }
</style>
